import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import type { IOrgUser } from "@/types";

interface AccessOverviewSummaryProps {
  currentTabUsers: IOrgUser[];
  adminCount: IOrgUser[];
  noAppAccess: IOrgUser[];
}

export default function AccessOverviewSummary(
  props: AccessOverviewSummaryProps,
) {
  const { t } = useTranslation("common");

  const stats = [
    {
      count: props.currentTabUsers.length,
      label: t("userManagement.accessOverview.users"),
    },
    {
      count: props.adminCount.length,
      label: t("userManagement.accessOverview.administrators"),
    },
    {
      count: props.noAppAccess.length,
      label: t("userManagement.accessOverview.withoutAppAccess"),
    },
  ];

  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "baseline",
        columnGap: 2,
        ".Mui-expanded &": { display: "none" },
      }}
    >
      {stats.map((stat, index) => (
        <Box
          key={stat.label}
          sx={{ display: "flex", alignItems: "baseline", columnGap: 2 }}
        >
          {index > 0 && (
            <Typography component="span" color="text.secondary">
              |
            </Typography>
          )}
          <Box component="span" sx={{ whiteSpace: "nowrap" }}>
            <Typography component="span" sx={{ fontWeight: "bold", pr: 0.5 }}>
              {stat.count}
            </Typography>
            <Typography component="span" variant="body2" color="text.secondary">
              - {stat.label}
            </Typography>
          </Box>
        </Box>
      ))}
    </Box>
  );
}
